<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :form="form">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="模板名称">
              <a-input  v-model="queryParam.templateName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="安装类别">
              <a-select  v-decorator="['installationType']"  @change="handleOrder" allowClear="true">
                <a-select-option  v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单类型">
              <a-select  v-decorator="['orderType']" allowClear="true">
                <a-select-option  v-for="type in restaurantTypes1" :title="type.typeName" :key="type.orderTypeId">{{type.typeName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6" :style="{ textAlign: 'right' }">
            <a-button  type="primary" htmlType="submit" @click="handleSelect">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearing">清空</a-button>
            <a-button v-if="exportEnable" style="margin-left: 8px" type="primary" @click="FileExcel">导出 Excel</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider></a-divider>
    <a-row>
      <a-col :span="5" :offset="19" :style="{ textAlign: 'right' }">
        <a-button v-if="editEnabel" type="primary"  icon="plus" @click="$refs.modal.add()">新增</a-button>
        <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
        <!--<a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>-->
        <!--</a-dropdown>-->
      </a-col>
    </a-row>
    <s-table
      style="margin-top: 20px"
      size="default"
      ref="table"
      rowKey="modelId"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="installationType" slot-scope="text, record">
         <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installationType == type.code">{{type.label}}</td>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleDeploy(record)">预览</a>
        <a-divider type="vertical" />
        <a v-if="queryList" @click="handleEdit(record,1)">查看</a>
        <a-divider v-if="queryList" type="vertical" />
        <span v-if="editEnabel">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="delByIds(record.templateId)">删除</a>
          <a-divider type="vertical" />
          <a v-if="record.isDisable==1" @click="showState(record.templateId,record.isDisable)">启用</a>
          <a v-else @click="showState(record.templateId,record.isDisable)">禁用</a>
        </span>
      </span>
    </s-table>
    <order-modal ref="modal" @ok="handleOk"/>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import { InfoTemplate,getTemplateList,getOrderTypeList,remove } from '@/api/basicdatas/OrderTemplate'
  import OrderModal from './modules/OrderModal.vue'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"
  import {ACCESS_TOKEN} from '@/store/mutation-types'

  export default {
    name: 'ModelList',
    components: {
      STable,
      OrderModal,
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'sort',
            align:'center'
          },
          {
            title: '操作',
            width:60,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
          {
            title: '模板名称',
            dataIndex: 'templateName',
            align:'center'
          },
          {
            title: '安装类别',
            dataIndex: 'installationType',
            scopedSlots: { customRender: 'installationType' },
            align:'center'
          },
          {
            title: '订单类型',
            dataIndex: 'typeName',
            align:'center'
          },
          {
            title: '最近修改时间',
            dataIndex: 'updateTime',
            align:'center'
          },
          {
            title: '操作人',
            dataIndex: 'updateBy',
            align:'center'
          }
        ],
        loadData: parameter => {
          return getTemplateList(Object.assign(parameter, this.queryParam))
        },
        fileList: [],
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        uploadUrl: process.env.VUE_APP_API_BASE_URL + '/enterprise/model/importModel',
        restaurantTypes:[],
        restaurantTypes1:[],
        data:[],
        editEnabel: checkPermission('basicdata:OrderTemplate:ediit'),
        exportEnable:checkPermission('basicdata:OrderTemplate:export'),
        queryList:checkPermission('basicdata:OrderTemplate:query'),
      }
    },
    filters: {
    },
    async created () {
      // document.body.addEventListener('keyup', e => {
      //   if (e.keyCode == 13) {
      //     this.handleSelect()
      //   }
      // })
      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
    },
    // destroyed () {
    //   document.body.removeEventListener('keyup', e => {})
    // },
    methods: {
      // 导出
      FileExcel(){
        var str=process.env.VUE_APP_API_BASE_URL + '/basicdata/template/exportInstallationInfoTemplate?pageNum=1&pageSize=10'
        for(let i in this.queryParam ){
          if(this.queryParam[i]!=undefined){
            str=str+'&'+i+'='+this.queryParam[i]
          }
        }
        str=str+'&token='+this.headers.token
        window.open(str)
        // InfoTemplate(this.queryParam).then(res=>{
        //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        //   const a = document.createElement('a')
        //   // 生成文件路径
        //   let href = window.URL.createObjectURL(blob)
        //   a.href = href
        //   let fileName = '订单安装模板'
        //   // 文件名中有中文 则对文件名进行转码
        //   a.download = decodeURIComponent(fileName)
        //   // 利用a标签做下载
        //   document.body.appendChild(a)
        //   a.click()
        //   document.body.removeChild(a)
        //   window.URL.revokeObjectURL(href)
        // })
      },
      handleSelect(){
        this.queryParam.installationType = this.form.getFieldValue('installationType')
        this.queryParam.orderType = this.form.getFieldValue('orderType')
        this.$refs.table.refresh(true)
      },
      handleAdd () {
        this.$refs.modal.add()
      },
      handleEdit (record,status) {
        this.$refs.modal.edit(record,status)
      },
      // 预览
      handleDeploy(record){
        this.$refs.modal.deploy(record)
      },
      clearing(){
        this.form.resetFields()
        this.queryParam={}
        this.restaurantTypes1=[]
      },
      handleOk (value) {
        if(value == 1){
          this.$refs.table.refresh(true)
        }else{
          this.$refs.table.refresh()
        }
      },
      showState (templateId,isDisable) {
        if (isDisable == 0) {
          remove({ 'templateId': templateId,'isDisable':1 }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (isDisable == 1) {
          remove({ 'templateId': templateId,'isDisable':0 }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('启动成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      handleChange(info) {
        // console.log(info)
        if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          this.$message.success('上传成功')

        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      },
      delByIds (templateId) {
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            remove({'templateId': templateId,'delStatus':1}).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                that.handleOk()
              } else {
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      },
      // 订单类型下拉
      handleOrder(value){
        this.restaurantTypes1 = []
        this.form.setFieldsValue({
          'orderType':undefined
        })
        getOrderTypeList(value).then(res => {
          console.log(res)
          this.restaurantTypes1 = res.rows
        })
      },
    },
    watch: {
      /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
    }
  }
</script>
<style scoped>
  /*.trebtn{
    width: 140px;
    color: white;
    background-color: #17A4E1;
    position: absolute;
    font-size: 15px;
    top: -90px;
    right: 100px;
  }*/
  .trebtn{
    width: 140px;
    color: white;
    background-color: #17A4E1;
    font-size: 15px;
    top: -90px;
    right: 100px;
  }

  .treo{
    right: 548px;
  }
  .treth{
    right: 248px;
  }
  .tret{
    right: 380px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
</style>
